module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_c('span', [_vm._v("生成兑换码")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "生成邀请码",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formFuzzy,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "数量:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "输入领取数量",
      "type": "number",
      "step": 1,
      "step-strictly": "",
      "onkeypress": "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))"
    },
    model: {
      value: (_vm.formFuzzy.couponCount),
      callback: function($$v) {
        _vm.$set(_vm.formFuzzy, "couponCount", $$v)
      },
      expression: "formFuzzy.couponCount"
    }
  })], 1)], 1), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "preventReClick",
      rawName: "v-preventReClick"
    }],
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.dialogConfirm
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-121c14dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/components/getCoupon.vue
// module id = 660
// module chunks = 1